import { useEffect, useState } from "react";
import moment from "moment";
import clsx from "clsx";
import { getIcon } from "utils/weatherIcons";
import { styled } from "@mui/material";
import NoContentFound from "../NoContentFound/NoContentFound";
import SubTitle from "../Typography/SubTitle";
import NormalText from "../Typography/NormalText";
import { WeatherDayStyled } from "./WeatherDayStyled";

const TempWrapper = styled("div")({
  //if we add classname "temp max-min" on the subtitles we get the old design
  "& .temp-subtitle": {
    fontSize: "14px",
  },
});

function checkDateStatus(inputDate) {
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const input = new Date(inputDate);
  input.setHours(0, 0, 0, 0);

  if (input < today) {
    return "past";
  } else if (input > today) {
    return "future";
  } else {
    return "today";
  }
}

const WeatherDayUnstyled = ({ day, className, isSelected, onClick }) => {
  const [iconCode, setIconCode] = useState("");
  const [dateToDisplay, setDateToDisplay] = useState("");
  const [dateStatus, setDateStatus] = useState("past");

  const handleClick = () => {
    onClick?.(day.timeAsDate);
  };

  useEffect(() => {
    const iconParts = day?.mainIcon.split("/");
    const iconName = iconParts[iconParts.length - 1];
    const iconCode = iconName.split(".")[0];
    setIconCode(iconCode);
    const date = moment(day?.timeAsDate);
    const formattedDate = date.format("DD MMM");
    setDateToDisplay(formattedDate);
    const pastTodayOrFuture = checkDateStatus(day?.timeAsDate);
    setDateStatus(pastTodayOrFuture);
  }, [day]);

  return (
    <WeatherDayStyled
      className={clsx(
        dateStatus,
        {
          interactive: typeof onClick === "function",
          selected: isSelected,
        },
        className,
      )}
      onClick={handleClick}
    >
      {day ? (
        <div className="title">
          <NormalText text={dateToDisplay} />
          <div className="box">
            <img src={getIcon(iconCode)} alt="weather-icon" />
            <TempWrapper className="temp-wrapper">
              <SubTitle text={`${day.maxTemp}°`} className="temp-subtitle" />
              <SubTitle text={`${day.minTemp}°`} className="temp-subtitle" />
            </TempWrapper>
          </div>
        </div>
      ) : (
        <NoContentFound text="Χωρίς δεδομένα" />
      )}
    </WeatherDayStyled>
  );
};

const WeatherDay = styled(WeatherDayUnstyled)({});

export default WeatherDay;
